import { render, staticRenderFns } from "./ArticleCategoryHeadlinesSection.vue?vue&type=template&id=5393f3a4&scoped=true&"
import script from "./ArticleCategoryHeadlinesSection.vue?vue&type=script&lang=ts&"
export * from "./ArticleCategoryHeadlinesSection.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleCategoryHeadlinesSection.vue?vue&type=style&index=0&id=5393f3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393f3a4",
  null
  
)

export default component.exports